import React from 'react'
import { PiCaretDoubleRightThin } from "react-icons/pi";

const ContactHero = () => {
  return (
      <div className='abouthero-backdiv'>
            <div className='backdiv'>
                <div className='about-herogrid'>
                    <div> 
                     <h2 className='main-heading'>EXPERT ADVICE. TRUSTED GUIDANCE. ONE CALL AWAY.</h2>
                   <p className='hero-small-text'>CONTACT US<PiCaretDoubleRightThin /> </p>
                    </div>
                    <div className='about-herodiv-wrapper'>
                      <div className='abt-wrap'>
                      <div className="about-herodiv-border">
                    <div className='about-herodiv'>
                        <img className='img-cover' src='./contact-hero3.webp' alt='about' loading='lazy'/>
                    </div>
                    </div>
                     <div className='about-herodiv-second'>
                       <div className='about-herodiv'>
                        <img className='img-cover' src='./contact-hero2.webp' alt='about' loading='lazy'/>
                    </div>
                    
                    </div>
                     <div className='about-herodiv-third'>
                       <div className='about-herodiv'>
                        <img className='img-cover' src='./contact-hero1.webp' alt='about' loading='lazy'/>
                    </div>
                    
                    </div>
                    </div>
                    </div>
           
            </div>
            </div>
        </div>
  )
}

export default ContactHero